if($('.type-page').length){
    if($('.customersReferences').length){
        if(sessionStorage.customersReferences) {
            $('.customersReferences').html(sessionStorage.customersReferences);  
            $('.referencesFeed').each(function() {
                const $carousel = $(this);
                const $closestTitle = $carousel.prev('.homepage-group-title');
                $carousel.slick({
                  slidesToShow: 6,
                  slidesToScroll: 1,
                  autoplay: false,
                  autoplaySpeed: 5000,
                  arrows: true,
                  infinite: true,
                  adaptiveHeight: false,
                  appendArrows: $closestTitle,
                  responsive: [
                    {
                      breakpoint: 1440,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                      }
                    },
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                      }
                    },
                    {
                      breakpoint: 991,
                      settings: {
                        speed: 300,
                        infinite: false,
                        adaptiveHeight: true,
                        slidesToShow: 2.2,
                        slidesToScroll: 2,
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        speed: 300,
                        infinite: false,
                        adaptiveHeight: true,
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                      }
                    }
                  ]
                });
              });            
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find(".customersReferences").html();
                null !== t && ($(".customersReferences").html(t))
            
                sessionStorage.customersReferences = $(".customersReferences").html();
                }
            })
            .done(function(){
                $('.referencesFeed').each(function() {
                    const $carousel = $(this);
                    const $closestTitle = $carousel.prev('.homepage-group-title');
                    $carousel.slick({
                      slidesToShow: 6,
                      slidesToScroll: 1,
                      autoplay: false,
                      autoplaySpeed: 5000,
                      arrows: true,
                      infinite: true,
                      adaptiveHeight: false,
                      appendArrows: $closestTitle,
                      responsive: [
                        {
                          breakpoint: 1440,
                          settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                          }
                        },
                        {
                          breakpoint: 1200,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                          }
                        },
                        {
                          breakpoint: 991,
                          settings: {
                            speed: 300,
                            infinite: false,
                            adaptiveHeight: true,
                            slidesToShow: 2.2,
                            slidesToScroll: 2,
                          }
                        },
                        {
                          breakpoint: 600,
                          settings: {
                            speed: 300,
                            infinite: false,
                            adaptiveHeight: true,
                            slidesToShow: 1.2,
                            slidesToScroll: 1,
                          }
                        }
                      ]
                    });
                  });
            });
        }
    }
    if($('.firmsLogo').length){
        if(sessionStorage.firmsLogo) {
            $('.firmsLogo').html(sessionStorage.firmsLogo);  
            const $closestTitleFirmsLogo =  $('.firmsFeed').prev('.homepage-group-title');
      $('.firmsFeed').slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        appendArrows: $closestTitleFirmsLogo,
        slidesToShow: 3,
        slidesToScroll: 1,
          responsive: [
              {
                  breakpoint: 1200,
                  settings: "unslick" // Odpojí slider při 1200px a vyšší
              },
              {
                  breakpoint: 1199,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      appendArrows: $closestTitleFirmsLogo,
                  }
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 3.1,
                      slidesToScroll: 1,
                      appendArrows: $closestTitleFirmsLogo,
                  }
              },
              {
                  breakpoint: 400,
                  settings: {
                      slidesToShow: 2.1,
                      slidesToScroll: 1,
                      appendArrows: $closestTitleFirmsLogo,
                  }
              }
          ]
      });            
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find(".firmsLogo").html();
                null !== t && ($(".firmsLogo").html(t))
            
                sessionStorage.firmsLogo = $(".firmsLogo").html();
                }
            })
            .done(function(){
                const $closestTitleFirmsLogo =  $('.firmsFeed').prev('.homepage-group-title');
      $('.firmsFeed').slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        appendArrows: $closestTitleFirmsLogo,
        slidesToShow: 3,
        slidesToScroll: 1,
          responsive: [
              {
                  breakpoint: 1200,
                  settings: "unslick" // Odpojí slider při 1200px a vyšší
              },
              {
                  breakpoint: 1199,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      appendArrows: $closestTitleFirmsLogo,
                  }
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 3.1,
                      slidesToScroll: 1,
                      appendArrows: $closestTitleFirmsLogo,
                  }
              },
              {
                  breakpoint: 400,
                  settings: {
                      slidesToShow: 2.1,
                      slidesToScroll: 1,
                      appendArrows: $closestTitleFirmsLogo,
                  }
              }
          ]
      });
            })
        }
    }

    
}